import { CollectionTimeOpt } from "../../models/collectionUnit";
import SecureBoxImg from '../../../assets/securebox.png';
import SmallCageImg from '../../../assets/smallcage.png';
import BigCageImg from '../../../assets/bigcage.png';

export interface SecurityCageMdl {
    optionNo: number;
    title: string;
    subTitle: string[];
    imageUrl: string;
    splLines: string[];
    otherLines: string[];
}

export const collectionTimeFromOption = [
    { key: "8", text: "8", value: 8, enable: false },
    { key: "9", text: "9", value: 9, enable: false },
    { key: "10", text: "10", value: 10, enable: false },
    { key: "11", text: "11", value: 11, enable: false },
    { key: "12", text: "12", value: 12, enable: false },
    { key: "13", text: "13", value: 13, enable: false },
    { key: "14", text: "14", value: 14, enable: false },
    { key: "15", text: "15", value: 15, enable: false },
    { key: "16", text: "16", value: 16, enable: false },
    { key: "17", text: "178", value: 17, enable: false },
]

export const collectionTimeOptionToggle = () => {
    const options: CollectionTimeOpt[] = [];
    for (const iterator of collectionTimeFromOption) {
        const opt: CollectionTimeOpt = {
            text: iterator.text,
            value: iterator.value,
            key: iterator.key,
            isDisable: false
        }
        options.push(opt)
    }
    return options;
}

export const collectionProductOption = [
    { key: "LAPTOP", text: "LAPTOPS", value: 'laptop', },
    { key: "DESKTOP", text: "DESKTOPS", value: 'desktop', },
    { key: "SERVERS", text: "SERVERS", value: 'server', },
    { key: "MONITOR", text: "MONITOR / TFTS", value: 'monitorTft', },
    { key: "DOCTSTATION", text: "DOCKSTATIONS / PORTS", value: 'dockStationPort', },
    { key: "HDD", text: "HDDS", value: 'hdd', },
    { key: "SMARTPHONE", text: "SMARTPHONES / TABLETS", value: 'smartPhoneTablet', },
    { key: "OFFICEPRINTER", text: "OFFICE PRINTERS", value: 'officePrinter', },
    { key: "MFPPRINTER", text: "MFP PRINTERS", value: 'mfpPrinter', },
    { key: "MICE", text: "MICE", value: 'mice', },
    { key: "KEYBOARD", text: "KEYBOARDS", value: 'keyboard', },
    { key: "CABLE", text: "CABLES", value: 'cable', },
    { key: "NETWORK", text: "NETWORKS", value: 'network', },
]

export const securityCageModalValues: readonly SecurityCageMdl[] = [
    {
        optionNo: 1,
        title: 'Security Cage (120*80*187 cm/max 500 kg load)',
        subTitle: ['Shipped and collected by Dachser truck'],
        imageUrl: BigCageImg,
        splLines: ['Capacity – max load 500 kg:'],
        otherLines: ['Medium size desktops 60 per cage', 'Large desktops  approx.. 30 per cage', 'Mini and tiny desktops 150 per cage (Beware of max weight)',
            'Laptops 150 per cage', 'TFTs/Screens – 25-30 per cage', '- Shelves are moveable']
    },
    {
        optionNo: 2,
        title: 'Security Mini-Cage (80*72*110 cm/max 300 kg load)',
        subTitle: ['Shipped and collected by Dachser truck'],
        imageUrl: SmallCageImg,
        splLines: ['Capacity – max load 300 kg:'],
        otherLines: ['Medium size desktops 30 per cage', 'Large desktops  approx.. 10 per cage', 'Mini and tiny desktops 50 per cage (Beware of max weight)',
            'Laptops 75 per cage', 'TFTs/Screens – No room', '- Shelf is moveable']
    },
    {
        optionNo: 3,
        title: 'Security Box (120*80*110 cm/max 450 kg load)',
        subTitle: ['Foldable Security box with lid measuring (when unfolded): 120*80*110 cm'],
        imageUrl: SecureBoxImg,
        splLines: ['Capacity - Max load 450 kg:'],
        otherLines: ['"Medium size desktops 40-50 per box', 'Large desktops  approx. 20 per box', 'Mini and tiny desktops 150 per box (Beware of max weight)',
            'Laptops 150 per box', 'TFTs/Screens – 20 per box', '- packing material must be provided locally']
    }
];

export const koNumber = "KONUMBER";
export const cgiRef = "CGIREF";
export const companyName = "COMPANYNAME";
export const city = "CITY";
export const country = "COUNTRY";
export const createDate = "CREATEDATE";
export const collectionDate = "COLLECTIONDATE";
export const euroPallet = "EURO PALLET";
export const euroHalfPallet = "EURO HALF PALLET";
export const other = "OTHER";

export const ccPalletOption = [
    { key: "1", text: euroPallet + ' 120L*80W cm', value: euroPallet },
    { key: "2", text: euroHalfPallet + ' 60L*80W cm', value: euroHalfPallet },
    { key: "3", text: other + ' – pls provide measurements', value: other },
]
